import { render, staticRenderFns } from "./MoveGroup.vue?vue&type=template&id=626a590c&"
import script from "./MoveGroup.vue?vue&type=script&lang=js&"
export * from "./MoveGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports